import { IconButton, useColorMode } from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

const ColorModeSwitcher = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <IconButton
      aria-label="Cambiar modo de color"
      icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
      onClick={(e) => {
        e.stopPropagation();
        toggleColorMode();
      }}
      variant="ghost"
      size="lg"
    />
  );
};

export default ColorModeSwitcher; 